<template>
  <div>
        <v-dialog v-model="dialog" persistent max-width="900">
            <v-card>
                <v-container>
                    <v-card-title>
                        <span class="overline">ハウスプレゼンテーション依頼内容</span>
                        <v-spacer></v-spacer>
                        <v-icon dark @click="toggleDialogHousePresentation(false)">mdi-close</v-icon>
                    </v-card-title>
                    <v-container>
                        <v-stepper v-model="step" vertical >
                            <v-container>
                                <!-- Step 1 -->
                                <template>
                                    <v-stepper-step :complete="step > 1" step="1" color="#455a64">
                                        <span class="caption font-weight-black">色を選択してください</span>
                                        <small class="caption">{{radio}}</small>
                                    </v-stepper-step>

                                    <v-stepper-content step="1">
                                        <!-- <v-radio-group v-model="$store.state.radio" dense v-if="this.$store.state.intRadio == '0009999'" >
                                            <template v-for="(requestContent, i) in requestContents">
                                                <v-radio
                                                    :key="i"
                                                    :label="requestContent.text" 
                                                    :value="requestContent.text"
                                                    class="mb-n1"
                                                    @click="proceedToNext()"
                                                ></v-radio>
                                                <p :key="i+'A'" class="caption pl-8 red--text mb-3">
                                                    {{ requestContent.desc }}
                                                </p>
                                            </template>
                                        </v-radio-group> -->

                                        <!-- v-if="requestContent.value != 0 " -->
                                        <v-radio-group v-model="$store.state.radio" dense>
                                            <template v-for="(requestContent, i) in requestContents">
                                                <v-radio
                                                    :key="i"
                                                    :label="requestContent.text" 
                                                    :value="requestContent.text"
                                                    :disabled="requestContent.text == '色情報を指示して依頼' && $store.state.finalPlanSiyo == 1"
                                                    class="mb-n1"
                                                    @click="proceedToNext()"
                                                ></v-radio>
                                                <p :key="i+'A'" class="caption pl-8 red--text mb-3">
                                                    {{ requestContent.desc }}
                                                </p>
                                            </template>
                                        </v-radio-group>
                                        <template>
                                            <v-spacer></v-spacer>
                                            <!-- <v-btn color="#455a64" small class="white--text" @click="proceedToNext()" :disabled="!$store.state.radio"> 継続する </v-btn> -->
                                        </template> 
                                    </v-stepper-content>
                                </template>

                                <!-- Step 2 -->
                                <template>
                                    <v-stepper-step :complete="step > 2" step="2" color="#455a64">
                                        <span class="caption font-weight-black">依頼パターン数を入力してください</span>
                                        <small class="caption">{{requestPattern}}</small>
                                    </v-stepper-step>
                                    <v-stepper-content step="2">
                                        <v-container>
                                            <v-autocomplete
                                                v-model="requestPattern" dense
                                                outlined :items="[1, 2, 3, 4]"
                                                @change="insertingHousePresentationContent(), radio == '色情報を指示して依頼' ? dialogHpRequestForm = true : openHp()"
                                                clearable>
                                            </v-autocomplete>
                                        </v-container>
                                        <!-- <template>
                                            <v-spacer></v-spacer>
                                            <v-btn  dark color="red" small @click="step--">
                                                Cancel
                                                キャンセル
                                            </v-btn>
                                            <v-btn
                                                color="#455a64" small class="white--text"
                                                @click="radio == '色情報を指示して依頼' ? dialogHpRequestForm = true : openHp()" :disabled="!requestPattern"
                                            >
                                                継続する
                                            </v-btn>
                                        </template> -->
                                    </v-stepper-content>
                                </template>

                                <template >
                                    <v-stepper-step :complete="step > 3" step="3" color="#455a64">
                                        <span class="caption font-weight-black">ハウスプレゼンテーション依頼書 </span>
                                    </v-stepper-step>
                                    <v-stepper-content step="3">
                                        <template v-if="radio == '仕様書に従って作成'">
                                            <v-row>
                                                <v-col cols="8">
                                                    <v-simple-table class="mainTable colorView">
                                                        <thead>
                                                        <tr>
                                                            <th style="width: 50px !important; text-align: left !important">  </th>
                                                            <th v-for="(count, i ) in requestPattern" :key="i">
                                                                {{ `パ一タン - ${count}` }}
                                                            </th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr>
                                                            <th style="width: 50px !important; text-align: left !important">視点方向: </th>
                                                            <td v-for="(count, i ) in requestPattern" :key="i"> 
                                                                <v-edit-dialog 
                                                                    :return-value.sync="patterns[count]">
                                                                <!-- @open="clickIt(item)"
                                                                    @save="UpdateDataIndi('details',toEdit.details, item)"
                                                                    @close="closeIT()" -->
                                                                    <v-tooltip bottom>
                                                                            <template v-slot:activator="{ on }">
                                                                                <span v-on="on"> {{ patterns[count].direction }} </span>
                                                                            </template>
                                                                            <span> {{patterns[count].direction}} </span>
                                                                        </v-tooltip>
                                                                    <template v-slot:input >
                                                                    <small class="overline" > 視点方向  </small>
                                                                        <v-autocomplete
                                                                            v-model="patterns[count].direction"
                                                                            name="details"
                                                                            outlined
                                                                            dense
                                                                            rows="2"
                                                                            :items="VIEW_DIRECTION_SELECTIONS"
                                                                            item-text="direction"
                                                                            item-value="direction"
                                                                        ></v-autocomplete>
                                                                    </template>
                                                                </v-edit-dialog>
                                                            </td>
                                                        </tr>
                                                        <!-- <tr>
                                                                <th style="width: 50px !important; text-align: left !important">視点高さ: : </th>
                                                                <td v-for="(count, i ) in requestPattern" :key="i">
                                                                    <v-edit-dialog persistent large >
                                                                        <v-tooltip bottom>
                                                                                <template v-slot:activator="{ on }">
                                                                                    <span v-on="on"> {{ patterns[count].height }} </span>
                                                                                </template>
                                                                                <span> {{ patterns[count].height }} </span>
                                                                            </v-tooltip>
                                                                        <template v-slot:input >
                                                                        <small class="overline" > 視点高さ </small>
                                                                            <v-autocomplete
                                                                                v-model="patterns[count].height"
                                                                                name="details"
                                                                                outlined
                                                                                dense
                                                                                rows="2"
                                                                                :items="viewHeightSelections"
                                                                            ></v-autocomplete>
                                                                        </template>
                                                                    </v-edit-dialog>
                                                                </td>
                                                        </tr> -->
                                                        </tbody>
                                                    </v-simple-table>
                                                    <!-- <div class="pt-8">
                                                        <v-spacer></v-spacer>
                                                        <v-btn dark color="red" small @click="step--">
                                                            キャンセル
                                                        </v-btn>
                                                        <v-btn
                                                            color="#455a64" small class="white--text"
                                                            @click="storeData()"
                                                        >
                                                            継続する
                                                        </v-btn>
                                                    </div> -->
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-img
                                                    lazy-src
                                                    contain
                                                    src="img/view.png"
                                                    alt="view.png"
                                                    ></v-img>
                                                </v-col>
                                            </v-row>
                                        </template>

                                        <template v-else> 
                                            <span class="caption"> Work In Progress </span> 
                                            <v-btn dark color="red" small @click="step--">
                                                キャンセル
                                            </v-btn>
                                            <v-btn
                                                color="#455a64" small class="white--text"
                                                @click="step++"
                                            >
                                                継続する
                                            </v-btn>
                                        </template>
                                    </v-stepper-content>
                                </template>

                                
                                <!-- <template>
                                    <v-stepper-step step="4" color="#455a64">
                                        Lorem Ipsum
                                    </v-stepper-step>
                                    <v-stepper-content step="4">
                                        <v-card
                                            color="grey lighten-1"
                                            class="mb-12"
                                            height="200px"
                                        ></v-card>
                                        <template>
                                            <v-spacer></v-spacer>
                                            <v-btn text small @click="step--">
                                                Cancel
                                            </v-btn>
                                            <v-btn
                                                color="#455a64" small class="white--text"
                                                @click="step = 1" 
                                            >
                                                継続する
                                            </v-btn>
                                        </template>
                                    </v-stepper-content>
                                </template> -->
                            </v-container>
                        </v-stepper>
                    </v-container>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <!-- <v-btn text type="submit">Submit</v-btn> -->
                        <!-- <v-btn dark color="red" v-show="!editMode" @click="toggleDialogHousePresentation(false)">キャンセル</v-btn> -->
                        <v-btn dark color="success" medium v-show="isSaveButtonVisible" @click="storeData()" style="width:10%;">保存</v-btn>
                        <v-btn dark color="red" medium @click="step--" v-show="step == 2 || step == 3" style="width:10%;">戻る</v-btn>
                    </v-card-actions>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialogHpRequestForm"
            persistent
            max-width="2000"
            width="1300">
            <v-card>
                <v-card-title>
                    <span class="headline">ハウスプレゼンテーション依頼書</span>
                    <v-spacer></v-spacer>
                    <v-icon @click="dialogHpRequestForm = false" dark>mdi-close</v-icon>
                </v-card-title>
                <v-container fluid>
                    <v-card-text>
                        <v-container fluid>
                            <v-simple-table class="requestView"  fixed-header height="75vh">
                                <thead>
                                    <tr></tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(header, i) in hpRequestHeaders" :key="i" class="text-center">
                                        
                                        <th colspan="2" class="left-sticky" style="width: 300px; font-size:22px !important; height: 100px !important; background-color: #D3D3D3 !important" v-if="header == '依頼日'">
                                            <p class="h1 font-weight-black mx-2">{{ header }}</p> 
                                        </th>
                                        
                                        <!-- <template  v-else-if="header == '視点方向' || header == '視点高さ' ">
                                            <th colspan="1" class="left-sticky" style="font-size:20px !important; height: 50px !important; background-color: #D3D3D3 !important">
                                                <p class="h1 font-weight-black mx-2">{{ header }}</p> 
                                            </th>

                                            <th colspan="1" rowspan="2" class="image-header-sticky"  v-if="header == '視点方向' ">
                                                <v-img
                                                    height="150"
                                                    width="150"
                                                    lazy-src
                                                    contain
                                                    src="img/view.png"
                                                    alt="view.png"
                                                ></v-img>
                                            </th>
                                        </template>

                                        <th v-else-if="header == 'N/A'" colspan="2" class="left-sticky" style="font-size:20px !important; height: 50px !important; background-color: #D3D3D3 !important">

                                        </th> -->

                                        <th colspan="2" class="left-sticky" style="font-size:20px !important; height: 50px !important;background-color: #D3D3D3 !important" v-else>
                                            <p class="h1 font-weight-black mx-2">{{ header }}</p> 
                                        </th>

                                        <!-- SECTION RECENT -->
                                        <template v-for="(item, ii) in existingHp">
                                                <!-- <td style="width: 250px;" :key="ii" :class="`pattern-${requestPattern}-${item}`" v-if="header == 'N/A'"> -->
                                                <td style="width: 250px;" :key="ii" :class="`pattern-${requestPattern}-${item}`" v-if="header == '依頼日'">
                                                    <p class="overline mx-2">パターン{{ii+1}}<br> {{item.temp_created}}</p>
                                                </td>
                                                <td :key="ii" :class="`pattern-${requestPattern}-${item}`" v-if="header == '図面番号'">
                                                    {{item.revision}}
                                                </td>
                                                <td :key="ii" :class="`pattern-${requestPattern}-${item}`" v-if="header == '建物タイプ'">
                                                    <v-autocomplete
                                                        v-model="item.house_type_id"
                                                        :items="HOUSE_TYPES"
                                                        item-text="name"
                                                        item-value="id"
                                                        readonly
                                                    >
                                                    </v-autocomplete>
                                                </td>

                                                <!--td 造作色 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii"  v-if="header == '造作色'">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td :key="ii" v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${item}`" v-if="header == '造作色'">
                                                            <v-container>
                                                                <v-combobox 
                                                                    readonly
                                                                    v-model="item.artificial_color"
                                                                    :items="FEATURE_COLOR" 
                                                                    item-text="feature_color_value"
                                                                    item-value="feature_color_name"
                                                                    > </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">造作色</span>
                                                </v-tooltip>
                                                

                                                <!--td 建具色 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii"  v-if="header == '建具色'">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on"  :class="`pattern-${requestPattern}-${item}`" style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    readonly
                                                                    v-model="item.fittings_color" 
                                                                    dense 
                                                                    :items="JOINERY_COLOR" 
                                                                    item-text="joinery_color_value" 
                                                                    item-value="joinery_color_name"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">建具色</span>
                                                </v-tooltip>

                                                <!--td フローリング(1F) -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii"  v-if="header == 'フローリング(1F)'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${item}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    readonly
                                                                    v-model="item.flooring_1f" dense 
                                                                    :items="filteredFlooring" 
                                                                    item-text="flooring_value" 
                                                                    item-value="flooring_name"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">フローリング(1F)</span>
                                                </v-tooltip>

                                                <!--td フローリング(2F) -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii"  v-if="header == 'フローリング(2F)'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td   v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${item}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    readonly
                                                                    v-model="item.flooring_2f" 
                                                                    dense 
                                                                    :items="filteredFlooring" 
                                                                    item-text="flooring_value" 
                                                                    item-value="flooring_name"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">フローリング(2F)</span>
                                                </v-tooltip>

                                                <!--td フローリング(3F) -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii"  v-if="header == 'フローリング(3F)'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td   v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${item}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    readonly
                                                                    v-model="item.flooring_3f" 
                                                                    dense 
                                                                    :items="filteredFlooring" 
                                                                    item-text="flooring_value" 
                                                                    item-value="flooring_name"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">フローリング(3F)</span>
                                                </v-tooltip>

                                                <!--td 階段色 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii"  v-if="header == '階段色'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${item}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    readonly
                                                                    v-model="item.staircase_color" 
                                                                    dense 
                                                                    :items="HP_STAIRS" 
                                                                    item-text="hp_stair_value" 
                                                                    item-value="hp_stair_name"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">階段色</span>
                                                </v-tooltip>

                                                <!--td キッチンセット -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii"  v-if="header == 'キッチンセット'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${item}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    readonly
                                                                    v-model="item.kitchen_set" dense :items="filteredKitchen" item-text="kitchen_set_value" item-value="kitchen_set_name"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">キッチンセット</span>
                                                </v-tooltip>
                                                
                                                <!--td キッチンカウンター -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii"  v-if="header == 'キッチンカウンター'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${item}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    readonly 
                                                                    v-model="item.kitchen_counter" dense :items="filteredKitchenSet" item-text="kitchen_value" item-value="kitchen_name"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">キッチンカウンター</span>
                                                </v-tooltip>

                                                <!--td スリットスライダー -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii"  v-if="header == 'スリットスライダー'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${item}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    readonly 
                                                                v-model="item.slit_slider" dense> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">スリットスライダー</span>
                                                </v-tooltip>

                                                <!--td 石目調ﾌﾛｰﾘﾝｸﾞ -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii"  v-if="header == '石目調ﾌﾛｰﾘﾝｸﾞ'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${item}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    readonly 
                                                                    v-model="item.stone_patterned_floor" dense :items="STONE_PATTERNS" item-value="stone_pattern_name" item-text="stone_pattern_value"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">石目調ﾌﾛｰﾘﾝｸﾞ</span>
                                                </v-tooltip>

                                                <!--td 吊押入ユニット HANGING CLOSET-->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii"  v-if="header == '吊押入ユニット'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${item}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    readonly
                                                                    v-model="item.hanging_closure_unit" dense :items="HANGING_CLOSET_LATTICES" item-value="hanging_closet_name" item-text="hanging_closet_value"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">吊押入ユニット</span>
                                                </v-tooltip>

                                                <!--td 格子引き戸 LATTICE SLIDING-->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii"  v-if="header == '格子引き戸'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${item}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    readonly
                                                                    v-model="item.grid_sliding_door" dense :items="LATTICE_SLIDING" item-value="lattice_sliding_name" item-text="lattice_sliding_value"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">格子引き戸</span>
                                                </v-tooltip>

                                                <!--td 視点方向 PERSPECTIVE DIRECTION -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii"  v-if="header == '視点方向'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${item}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    readonly
                                                                    v-model="item.perspective_direction" dense :items="VIEW_DIRECTION_SELECTIONS" item-value="direction" item-text="direction"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">視点方向</span>
                                                </v-tooltip>

                                                <!--td 畳 TATAMI -->
                                                <td :key="ii" :class="`pattern-${requestPattern}-${item}`" v-if="header == '畳'">
                                                    <v-container>
                                                        <span class="caption">{{ item.tatami_type }}</span>
                                                        <span class="caption" v-if="item.tatami_type && item.tatami_color"> / </span>
                                                        <span class="caption">{{ item.tatami_color }}</span>
                                                    </v-container>
                                                </td>
                                        </template>

                                        <template>
                                            <td style="background-color: #D3D3D3 !important" class="req-divider"></td>
                                        </template>

                                        <template v-for="(pattern, ii) in requestPattern">
                                        
                                            <!-- NEW REQUEST -->
                                            <template v-if="!editMode">
                                                <!-- <td style="width: 250px;" :key="ii + header" :class="`pattern-${requestPattern}-${pattern}`" v-if="header == 'N/A'"> -->
                                                <td style="width: 250px;" :key="ii + header" :class="`pattern-${requestPattern}-${pattern}`" v-if="header == '依頼日'">
                                                    <v-btn @click="openPreviousSelection(ii)">コピー</v-btn>
                                                    <v-btn @click="setEmptySelection(ii)">仕様書に準ずる</v-btn>
                                                </td>
                                                <td :key="ii + header" :class="`pattern-${requestPattern}-${pattern}`" v-if="header == '図面番号'">
                                                    {{cadRequestLatestRevision}}
                                                </td>
                                                <td :key="ii + header" :class="`pattern-${requestPattern}-${pattern}`" v-if="header == '建物タイプ'">
                                                    <v-autocomplete
                                                        v-model="cadRequestBasicInformation.house_type_id"
                                                        :items="HOUSE_TYPES"
                                                        item-text="name"
                                                        item-value="id"
                                                        readonly
                                                    >
                                                    </v-autocomplete>
                                                </td>

                                                <!--td 造作色 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '造作色'">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td :key="ii + header" v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`" v-if="header == '造作色'">
                                                            <v-container>
                                                                <v-combobox 
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 
                                                                    v-model="cad_request_house_presentation[ii].artificial_color" 
                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                    dense 
                                                                    :items="FEATURE_COLOR" 
                                                                    item-text="feature_color_value"
                                                                    item-value="feature_color_name"
                                                                    > </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">造作色</span>
                                                </v-tooltip>
                                                

                                                <!--td 建具色 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '建具色'">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on"  :class="`pattern-${requestPattern}-${pattern}`" style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 
                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                    v-model="cad_request_house_presentation[ii].fittings_color" 
                                                                    dense 
                                                                    :items="JOINERY_COLOR" 
                                                                    item-text="joinery_color_value" 
                                                                    item-value="joinery_color_name"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">建具色</span>
                                                </v-tooltip>

                                                <!--td フローリング(1F) -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'フローリング(1F)'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 
                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                    v-model="cad_request_house_presentation[ii].flooring_1f" dense :items="filteredFlooring" item-text="flooring_value" item-value="flooring_name"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">フローリング(1F)</span>
                                                </v-tooltip>

                                                <!--td フローリング(2F) -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'フローリング(2F)'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td   v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 

                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                v-model="cad_request_house_presentation[ii].flooring_2f" dense :items="filteredFlooring" item-text="flooring_value" item-value="flooring_name"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">フローリング(2F)</span>
                                                </v-tooltip>

                                                <!--td フローリング(3F) -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'フローリング(3F)'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td   v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 

                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                v-model="cad_request_house_presentation[ii].flooring_3f" dense :items="filteredFlooring" item-text="flooring_value" item-value="flooring_name"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">フローリング(3F)</span>
                                                </v-tooltip>

                                                <!--td 階段色 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '階段色'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 

                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                v-model="cad_request_house_presentation[ii].staircase_color" dense :items="HP_STAIRS" item-text="hp_stair_value" item-value="hp_stair_name"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">階段色</span>
                                                </v-tooltip>

                                                <!--td キッチンセット -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'キッチンセット'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 

                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                    v-model="cad_request_house_presentation[ii].kitchen_set" dense :items="filteredKitchen" item-text="kitchen_set_value" item-value="kitchen_set_name"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">キッチンセット</span>
                                                </v-tooltip>
                                                
                                                <!--td キッチンカウンター -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'キッチンカウンター'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox 
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 
                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                    v-model="cad_request_house_presentation[ii].kitchen_counter" dense :items="filteredKitchenSet" item-text="kitchen_value" item-value="kitchen_name"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">キッチンカウンター</span>
                                                </v-tooltip>

                                                <!--td スリットスライダー -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'スリットスライダー'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox 
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 
                                                                    :items="SLIT_SLIDERS" item-value="slitslider_name" item-text="slitslider_value"
                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                    v-model="cad_request_house_presentation[ii].slit_slider" dense> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">スリットスライダー</span>
                                                </v-tooltip>

                                                <!--td 石目調ﾌﾛｰﾘﾝｸﾞ -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '石目調ﾌﾛｰﾘﾝｸﾞ'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox 
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 
                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                    v-model="cad_request_house_presentation[ii].stone_patterned_floor" dense :items="STONE_PATTERNS" item-value="stone_pattern_name" item-text="stone_pattern_value"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">石目調ﾌﾛｰﾘﾝｸﾞ</span>
                                                </v-tooltip>

                                                <!--td 吊押入ユニット HANGING CLOSET-->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '吊押入ユニット'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 
                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                    v-model="cad_request_house_presentation[ii].hanging_closure_unit" dense :items="HANGING_CLOSET_LATTICES" item-value="hanging_closet_name" item-text="hanging_closet_value"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">吊押入ユニット</span>
                                                </v-tooltip>

                                                <!--td 格子引き戸 LATTICE SLIDING-->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '格子引き戸'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 
                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                    v-model="cad_request_house_presentation[ii].grid_sliding_door" dense :items="LATTICE_SLIDING" item-value="lattice_sliding_name" item-text="lattice_sliding_value"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">格子引き戸</span>
                                                </v-tooltip>

                                                <!--td 視点方向 PERSPECTIVE DIRECTION-->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '視点方向'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 
                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                    v-model="cad_request_house_presentation[ii].perspective_direction" dense :items="VIEW_DIRECTION_SELECTIONS" item-value="direction" item-text="direction"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">視点方向</span>
                                                </v-tooltip>

                                                <!--td 畳 TATAMI -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important" :key="ii + header" v-if="header == '畳'">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                            :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)"
                                                            style="cursor: pointer"
                                                            @click="HP_RESTRICTIONS_PER_HOUSE.includes(header) && openTatamiDialog(ii, false)"
                                                        >
                                                            <v-container>
                                                                <span class="caption">{{ cad_request_house_presentation[ii].tatami_type }}</span>
                                                                <span class="caption" v-if="cad_request_house_presentation[ii].tatami_type && cad_request_house_presentation[ii].tatami_color"> / </span>
                                                                <span class="caption">{{ cad_request_house_presentation[ii].tatami_color }}</span>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">畳</span>
                                                </v-tooltip>
                                            </template>
                                            
                                            <!-- EDIT REQUEST -->
                                            <template v-else>
                                                <!-- <td style="width: 250px;" :key="ii + header" :class="`pattern-${requestPattern}-${pattern}`" v-if="header == 'N/A'"> -->
                                                <td style="width: 250px;" :key="ii + header" :class="`pattern-${requestPattern}-${pattern}`" v-if="header == '依頼日'">
                                                    <v-btn @click="openPreviousSelection(ii)">コピー</v-btn>
                                                    <v-btn @click="setEmptySelection(ii)">仕様書に準ずる</v-btn>
                                                </td>
                                                <td :key="ii + header" :class="`pattern-${requestPattern}-${pattern}`" v-if="header == '図面番号'">
                                                    {{editRevision}}
                                                </td>
                                                <td :key="ii + header" :class="`pattern-${requestPattern}-${pattern}`" v-if="header == '建物タイプ'">
                                                    <v-autocomplete
                                                        v-model="editCadRequestRevisionContent.house_type_id"
                                                        :items="HOUSE_TYPES"
                                                        item-text="name"
                                                        item-value="id"
                                                        readonly
                                                    >
                                                    </v-autocomplete>
                                                </td>

                                                <!--td 造作色 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '造作色'">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td :key="ii + header" v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`" v-if="header == '造作色'">
                                                            <v-container>
                                                                <v-combobox 
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 
                                                                    v-model="edit_cad_request_house_presentation[ii].artificial_color" 
                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                    dense
                                                                    clearable 
                                                                    :items="FEATURE_COLOR" 
                                                                    item-value="feature_color_name"
                                                                    item-text="feature_color_value"
                                                                    > </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">造作色</span>
                                                </v-tooltip>
                                                

                                                <!--td 建具色 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '建具色'">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on"  :class="`pattern-${requestPattern}-${pattern}`" style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 
                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                    v-model="edit_cad_request_house_presentation[ii].fittings_color" 
                                                                    dense 
                                                                    clearable
                                                                    :items="JOINERY_COLOR" 
                                                                    item-value="joinery_color_name" 
                                                                    item-text="joinery_color_value"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">建具色</span>
                                                </v-tooltip>

                                                <!--td フローリング(1F) -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'フローリング(1F)'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    clearable
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 
                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                    v-model="edit_cad_request_house_presentation[ii].flooring_1f" dense :items="filteredFlooring" item-value="flooring_name" item-text="flooring_value"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">フローリング(1F)</span>
                                                </v-tooltip>

                                                <!--td フローリング(2F) -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'フローリング(2F)'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td   v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    clearable
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 
                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                v-model="edit_cad_request_house_presentation[ii].flooring_2f" dense :items="filteredFlooring" item-value="flooring_name" item-text="flooring_value"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">フローリング(2F)</span>
                                                </v-tooltip>

                                                <!--td フローリング(3F) -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'フローリング(3F)'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td   v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    clearable
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 
                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                v-model="edit_cad_request_house_presentation[ii].flooring_3f" dense :items="filteredFlooring" item-value="flooring_name" item-text="flooring_value"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">フローリング(3F)</span>
                                                </v-tooltip>

                                                <!--td 階段色 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '階段色'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    clearable
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 
                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                v-model="edit_cad_request_house_presentation[ii].staircase_color" dense :items="HP_STAIRS" item-value="hp_stair_name" item-text="hp_stair_value"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">階段色</span>
                                                </v-tooltip>

                                                <!--td キッチンセット -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'キッチンセット'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    clearable
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 
                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                    v-model="edit_cad_request_house_presentation[ii].kitchen_set" dense :items="filteredKitchen" item-value="kitchen_set_name" item-text="kitchen_set_value"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">キッチンセット</span>
                                                </v-tooltip>
                                                
                                                <!--td キッチンカウンター -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'キッチンカウンター'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox 
                                                                    clearable
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 
                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                    v-model="edit_cad_request_house_presentation[ii].kitchen_counter" dense :items="filteredKitchenSet" item-value="kitchen_name" item-text="kitchen_value"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">キッチンカウンター</span>
                                                </v-tooltip>

                                                <!--td スリットスライダー -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'スリットスライダー'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    clearable 
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 
                                                                    :items="SLIT_SLIDERS" item-value="slitslider_name" item-text="slitslider_value"
                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                    v-model="edit_cad_request_house_presentation[ii].slit_slider" dense> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">スリットスライダー</span>
                                                </v-tooltip>

                                                <!--td 石目調ﾌﾛｰﾘﾝｸﾞ -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '石目調ﾌﾛｰﾘﾝｸﾞ'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox 
                                                                    clearable
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 
                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                    v-model="edit_cad_request_house_presentation[ii].stone_patterned_floor" dense :items="STONE_PATTERNS" item-value="stone_pattern_name" item-text="stone_pattern_value"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">石目調ﾌﾛｰﾘﾝｸﾞ</span>
                                                </v-tooltip>

                                                <!--td 吊押入ユニット HANGING CLOSET-->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '吊押入ユニット'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    clearable
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 
                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                    v-model="edit_cad_request_house_presentation[ii].hanging_closure_unit" dense :items="HANGING_CLOSET_LATTICES" item-value="hanging_closet_name" item-text="hanging_closet_value"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">吊押入ユニット</span>
                                                </v-tooltip>

                                                <!--td 格子引き戸 LATTICE SLIDING-->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '格子引き戸'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    clearable
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 
                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                    v-model="edit_cad_request_house_presentation[ii].grid_sliding_door" dense :items="LATTICE_SLIDING" item-value="lattice_sliding_name" item-text="lattice_sliding_value"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">格子引き戸</span>
                                                </v-tooltip>
                                                
                                                <!--td 視点方向 PERSPECTIVE DIRECTION-->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '視点方向'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox
                                                                    clearable
                                                                    :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)" 
                                                                    :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                                    v-model="edit_cad_request_house_presentation[ii].perspective_direction" dense :items="VIEW_DIRECTION_SELECTIONS" item-value="direction" item-text="direction"> </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">視点方向</span>
                                                </v-tooltip>

                                                <!--td 畳 TATAMI -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important" :key="ii + header" v-if="header == '畳'">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            :class="`pattern-${requestPattern}-${pattern}`"
                                                            :style="!HP_RESTRICTIONS_PER_HOUSE.includes(header) ? 'background-color: #34495e' : ''"
                                                            :disabled="!HP_RESTRICTIONS_PER_HOUSE.includes(header)"
                                                            style="cursor: pointer"
                                                            @click="HP_RESTRICTIONS_PER_HOUSE.includes(header) && openTatamiDialog(ii, true)"
                                                        >
                                                            <v-container>
                                                                <span class="caption">{{ edit_cad_request_house_presentation[ii].tatami_type }}</span>
                                                                <span class="caption" v-if="edit_cad_request_house_presentation[ii].tatami_type && edit_cad_request_house_presentation[ii].tatami_color"> / </span>
                                                                <span class="caption">{{ edit_cad_request_house_presentation[ii].tatami_color }}</span>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">畳</span>
                                                </v-tooltip>
                                            </template>
                                        </template>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-container>
                    </v-card-text>
                </v-container>
                    <div>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <!-- <v-btn color="red" @click="closeDialogHpRequestForm()" dark dense>キャンセル</v-btn> -->
                            <v-btn color="red" @click="closeDialogHpRequestForm()" dark dense>戻る</v-btn>
                            <v-btn color="success" @click="saveHousePresentation()" dark dense>保存</v-btn>
                        </v-card-actions>
                    </div>
            </v-card>   
        </v-dialog>

        <!-- TATAMI (畳) SELECTION -->
        <v-dialog v-model="dialogTatamiSelection" max-width="400" persistent>
            <v-card>
                <v-card-title>
                    <span class="overline">畳 (TATAMI) を選択してください</span>
                    <v-spacer></v-spacer>
                    <v-icon dark @click="closeTatamiDialog()">mdi-close</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-col cols="12">
                        <v-autocomplete 
                            v-model="tatamiSelectedType"
                            :items="filteredTatamiTypes"
                            item-text="tatami_type"
                            item-value="tatami_type_id"
                            return-object
                            outlined
                            dense
                            clearable
                            label="Tatami Type"
                            @change="tatamiSelectedColor = null"
                            hide-details
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                        <v-autocomplete
                            v-model="tatamiSelectedColor"
                            :items="filteredTatamiColors"
                            item-text="tatami_color"
                            item-value="tatami_color_id"
                            return-object
                            outlined
                            dense
                            clearable
                            label="Tatami Color"
                            :disabled="!tatamiSelectedType"
                            hide-details
                        ></v-autocomplete>
                    </v-col>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red" dark dense @click="closeTatamiDialog()">戻る</v-btn>
                    <v-btn color="success" dark dense :disabled="!tatamiSelectedType || !tatamiSelectedColor" @click="saveTatamiSelection()">保存</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!-- COPY PREVIOUS PATTERN -->
        <v-dialog v-model="previousHP" persistent width="28%">
            <v-card>
                <v-card-title> <v-spacer/><v-icon @click="previousHP = false" large color="red">mdi-close</v-icon></v-card-title>
                <v-card-text>
                    <v-row no-gutters>
                        <v-col width="50%">
                            <center>
                                <v-simple-table style="width: 250px !important;" class="ml-2">
                                    <thead>
                                        <tr>
                                            <th style="font-size: 15px !important;">SELECT REVISION PLAN</th>
                                            <!-- <th style="font-size: 15px !important;">SELECT PATTERN</th> -->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in existingHp" :key="index">
                                            <td style="border: none !important">      
                                                <span style="font-size: 15px !important;">{{item.temp_created}}</span>
                                                <v-btn style="margin-left: 25px !important; margin-right: 25px !important;" @click="copyToLatest(item)" dense color="primary"
                                                :disabled="disableCopyPrevious(item)">{{item.revision}}</v-btn>
                                                <span style="font-size: 15px !important;">No. {{index+1}}</span>
                                            </td>
                                            <!-- <td>
                                                <span style="font-size: 15px !important;">パ一タン</span>
                                                <v-btn style="margin-left: 25px !important; margin-right: 25px !important;" dense color="primary">{{index}}</v-btn>
                                            </td> -->
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </center>
                        </v-col>
                        <v-col class="pr-0 mr-0" width="50%">
                            <v-simple-table style="width: 230px !important;">
                                <thead>
                                    <tr>
                                        <!-- <th style="font-size: 15px !important;">SELECT REVISION PLAN</th> -->
                                        <th style="font-size: 15px !important;">SELECT PATTERN</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in requestPattern" :key="index">
                                        <!-- <td >      
                                            <span style="font-size: 15px !important;">{{item.temp_created}}</span>
                                            <v-btn style="margin-left: 25px !important; margin-right: 25px !important;" @click="copyToLatest(item)" dense color="primary">{{item.revision}}</v-btn>
                                            <span style="font-size: 15px !important;">No. {{index+1}}</span>
                                        </td> -->
                                        <td v-if="item != newIndex+1" style="border: none !important">
                                            <span style="font-size: 15px !important;">パ一タン</span>
                                            <v-btn style="margin-left: 25px !important;" @click="setPattern(item-1)" dense color="primary">{{item}}</v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>


                </v-card-text><br>
                <!-- <v-card-actions><v-spacer/>
                    <v-btn @click="acceptNoRequestColors()" color="success" dark depressed width="80px">Yes</v-btn>
                    <v-btn @click="closeNoRequestColors()" depressed color="#E74C3C" class="white--text" width="80px">戻る</v-btn>
                </v-card-actions> -->
            </v-card>
        </v-dialog>
        <!-- ****** -->


        <v-dialog v-model="noRequestDialog" width="26%" persistent>
            <!-- <v-form id="noRequest" ref="noRequest" @submit.prevent="noRequest"> -->
                <v-card>
                    <v-card-title>
                        <span class="overline">ハウスプレゼンテーション依頼内容</span>
                    </v-card-title><v-spacer/>
                    <v-card-text>
                        <div class="ml-4 mt-3 overline" style="font-size:18px !important;">
                            依頼はなしで良いでしょうか。
                        </div>
                    </v-card-text>
                    <v-card-actions><v-spacer/>
                        <v-btn @click="acceptNoRequest()" color="success" dark depressed width="80px">Yes</v-btn>
                        <v-btn @click="closeNoRequest()" depressed color="#E74C3C" class="white--text" width="80px">戻る</v-btn>
                    </v-card-actions>
                </v-card>
            <!-- </v-form> -->
        </v-dialog>

    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import moment from 'moment';
export default {
    // props: {
    //     dialog : Boolean
    // }, 
    props:["housePresentation","dialog"],
    data(){
        return {
            previousHP: false,
            noRequestDialog : false,
            filteredKitchen: [],
            filteredKitchenSet: [],
            filteredFlooring: [],
            // radio: null,
            step: 1,
            requestContents: [
                // {text: "展示場内装確認（打合せ用）INT", value:0},
                {text: "仕様書に従って作成", desc: "※仕様書指示がない場合はおまかせで作成", value:1},
                {text: "色情報を指示して依頼", desc: "※着⼿図⾯依頼以降は選択不可", value:2},
                {text: "依頼なし", desc: "", value:3},
            ],
            viewDirectionSelections: [
                "1",
                "1-2",
                "2",
                "2-3",
                "3",
                "3-4",
                "4",
                "4-5",
                "5",
                "5-6",
                "6",
                "6-7",
                "7",
                "7-8",
                "8",
                "8-9",
                "9",
                "9-10",
                "10",
                "10-11",
                "11",
                "11-12",
                "12",
                "12-1",
            ],
            viewHeightSelections: [
                "LU",
                "1600",
                "1800",
                "2000",
                "2500",
                "3000",
                "3500",
                "4000",
                "4500",
                "5000",
                "5500",
                "6000",
                "6500",
                "7000",
                "7500",
                "8000",
                "8500", 
                "9000", 
                "9500", 
                "10000",
                "10500", 
                "11000",
                "11500",
                "12000",
            ],
            requestPattern: 0,
            patterns : {
                1: { direction: null, height: null },
                2: { direction: null, height: null },
                3: { direction: null, height: null },
                4: { direction: null, height: null },
                5: { direction: null, height: null },
            },
            dialogHpRequestForm: false,
            hpRequestHeaders: [
                // 'N/A'
                '依頼日',
                '図面番号',
                '建物タイプ',
                '造作色',
                '建具色',
                'フローリング(1F)',
                'フローリング(2F)',
                'フローリング(3F)',
                '階段色',
                'キッチンセット',
                'キッチンカウンター',
                'スリットスライダー',
                '石目調ﾌﾛｰﾘﾝｸﾞ',
                '吊押入ユニット',
                '格子引き戸',
                '視点方向',
                '畳'
                // '視点方向',
            ],

            featureColorSelection: [
                "",
                { text: "ｼｮｺﾗﾌﾞﾗｳﾝ (CB)", value: "CB" },
                { text: "ﾋﾟｭｱﾒｲﾌﾟﾙ (PM)", value: "PM" },
            ],

            joineryColorSelection: [
                "",
                { text: "ホワイト (WH)", value: "WH" },
                { text: "ライト (LT)", value: "LT" },
                { text: "グレー (G)", value: "G" },
                { text: "ダーク (D)", value: "D" },
            ],

            smartFlooringSelection: [
                "",
                { text: "ﾌﾟﾚｰﾝ (P)", value: "P" },
                { text: "ﾅﾁｭﾗﾙ (N)", value: "N" },
                { text: "ｼｮｺﾗﾌﾞﾗｳﾝ (CB)", value: "CB" },
                { text: "ﾐﾃﾞｨｱﾑ (M)", value: "M" },
                { text: "ﾎﾜｲﾄ・ｳｫｰﾙﾅｯﾄ (WW)", value: "WW" },
                { text: "ﾗｲﾄ・ｳｫｰﾙﾅｯﾄ (LW)", value: "LW" },
                { text: "ｸﾞﾚｰ・ｳｫｰﾙﾅｯﾄ (GW)", value: "GW" },
                { text: "ﾚｯﾄﾞ・ﾁｪﾘｰ (RC)", value: "RC" },
                { text: "ﾋﾞﾀｰ・ｳｫｰﾙﾅｯﾄ (BW)", value: "BW" },
                { text: "ﾌﾞﾗｯｸｳｫｰﾙﾅｯﾄ (BKW)", value: "BKW" },
                { text: "ﾁｰｸ (CH)", value: "CH" },
                { text: "ｻﾍﾟﾘ (SP)", value: "SP" },
                { text: "ｶﾘﾝ (KR)", value: "KR" },
                { text: "ﾌﾞﾗｯｸｳｫｰﾙﾅｯﾄ (BWP)", value: "BWP" },
                { text: "ﾊｰﾄﾞﾒｲﾌﾟﾙ (HM)", value: "HM" },
                { text: "ｵｰｸ (OK)", value: "OK" },
            ],

            smileFlooringSelection: [
                "",
                { text: "ﾗｲﾄ・ｳｫｰﾙﾅｯﾄ (LW)", value: "LW" },
                { text: "ｸﾞﾚｰ・ｳｫｰﾙﾅｯﾄ (GW)", value: "GW" },
                { text: "ﾋﾞﾀｰ・ｳｫｰﾙﾅｯﾄ (BW)", value: "BW" },
            ],

            cubeFlooringSelection: [
                "",
                { text: "ﾌﾟﾚｰﾝ (P)", value: "P" },
                { text: "ﾅﾁｭﾗﾙ (N)", value: "N" },
                { text: "ｼｮｺﾗﾌﾞﾗｳﾝ (CB)", value: "CB" },
                { text: "ﾌﾞﾗｯｸｳｫｰﾙﾅｯﾄ (BKW)", value: "BKW" },
                { text: "ﾁｰｸ (CH)", value: "CH" },
                { text: "ｻﾍﾟﾘ (SP)", value: "SP" },
                { text: "ｶﾘﾝ (KR)", value: "KR" },
                { text: "ﾌﾞﾗｯｸｳｫｰﾙﾅｯﾄ (BWP)", value: "BWP" },
                { text: "ﾊｰﾄﾞﾒｲﾌﾟﾙ (HM)", value: "HM" },
                { text: "ｵｰｸ (OK)", value: "OK" },
            ],

            jikuFlooringSelection: [
                "",
                { text: "ﾅﾁｭﾗﾙ (N)", value: "N" },
                { text: "ﾐﾃﾞｨｱﾑ (M)", value: "M" },
                { text: "ﾀﾞｰｸ (LD)", value: "LD" },
                { text: "ﾌﾟﾚｰﾝ (P)", value: "P" },
                { text: "ｼｮｺﾗﾌﾞﾗｳﾝ (CB)", value: "CB" },
                { text: "ﾌﾞﾗｯｸｳｫｰﾙﾅｯﾄ (BKW)", value: "BKW" },
                { text: "ﾁｰｸ (CH)", value: "CH" },
                { text: "ｻﾍﾟﾘ (SP)", value: "SP" },
                { text: "ｶﾘﾝ (KR)", value: "KR" },
                { text: "ﾌﾞﾗｯｸｳｫｰﾙﾅｯﾄ (BWP)", value: "BWP" },
                { text: "ﾊｰﾄﾞﾒｲﾌﾟﾙ (HM)", value: "HM" },
                { text: "ｵｰｸ (OK)", value: "OK" },
            ],

            grandFlooringSelection: [
                "",
                { text: "ﾎﾜｲﾄ・ｳｫｰﾙﾅｯﾄ (WWT)", value: "WWT" },
                { text: "ﾗｲﾄ・ｳｫｰﾙﾅｯﾄ (LWT)", value: "LWT" },
                { text: "ﾋﾞﾀｰ・ｳｫｰﾙﾅｯﾄ (BWT)", value: "BWT" },
                { text: "ｸﾞﾚｰ・ｳｫｰﾙﾅｯﾄ (GWT)", value: "GWT" },
                { text: "ﾌﾞﾗｯｸｳｫｰﾙﾅｯﾄ (BKW)", value: "BKW" },
                { text: "ﾁｰｸ (CH)", value: "CH" },
                { text: "ｻﾍﾟﾘ (SP)", value: "SP" },
                { text: "ｶﾘﾝ (KR)", value: "KR" },
                { text: "ﾌﾞﾗｯｸｳｫｰﾙﾅｯﾄ (BWP)", value: "BWP" },
                { text: "ﾊｰﾄﾞﾒｲﾌﾟﾙ (HM)", value: "HM" },
                { text: "ｵｰｸ (OK)", value: "OK" },
            ],

            smartGrandStairSelection: [
                "",
                { text: "ﾗｲﾄ (LIT)", value: "LIT" },
                { text: "ﾋﾞﾀｰ (BTR)", value: "BTR" },
                { text: "ﾚｯﾄﾞ (RED)", value: "RED" },
            ],

            smileCubeStairSelection: [
                "",
                { text: "ﾗｲﾄ (LIT)", value: "LIT" },
                { text: "ﾋﾞﾀｰ (BTR)", value: "BTR" },
            ],
            jikuStairSelection: [
                "",
                { text: "ﾅﾁｭﾗﾙ (N)", value: "N" },
                { text: "ﾐﾃﾞｨｱﾑ (M)", value: "M" },
                { text: "ﾀﾞｰｸ (LD)", value: "LD" },
                { text: "ﾗｲﾄ (LT)", value: "LT" },
                { text: "ﾋﾞﾀｰ (BT)", value: "BT" },
            ],

            kitchenSetSelection: [
                "",
                { text: "ﾀﾞｰｸ (D)", value: "D" },
                { text: "ﾃﾞｨｱﾑ (M)", value: "M" },
                { text: "ﾅﾁｭﾗﾙ (N)", value: "N" },
                { text: "ﾎﾜｲﾄ・ｳｫｰﾙﾅｯﾄ (WWT)", value: "WWT" },
                { text: "ﾗｲﾄ・ｳｫｰﾙﾅｯﾄ (LWT)", value: "LWT" },
                { text: "ﾋﾞﾀｰ・ｳｫｰﾙﾅｯﾄ (BWT)", value: "BWT" },
                { text: "ﾌﾟﾚﾐｱﾑ･ﾌﾞﾗｳﾝ (RBW)", value: "RBW" },
                { text: "ﾌﾟﾚﾐｱﾑ･ﾚｯﾄﾞ (RRD)", value: "RRD" },
                { text: "ﾌﾟﾚﾐｱﾑ･ﾌﾞﾗｯｸ (RBK)", value: "RBK" },
                { text: "ﾌﾟﾚﾐｱﾑ･ﾎﾜｲﾄ (RWH)", value: "RWH" },
                { text: "ﾋﾟｱﾉ･ﾌﾞﾗｳﾝ (PBW)", value: "PBW" },
                { text: "ﾋﾟｱﾉ･ﾚｯﾄﾞ (PRE)", value: "PRE" },
                { text: "ﾋﾟｱﾉ･ｱｲﾎﾞﾘｰ (PIV)", value: "PIV" },
                { text: "ﾋﾟｱﾉ･ﾋﾟｰﾁ (PPE)", value: "PPE" },
                { text: "ﾋﾟｱﾉ･ﾎﾜｲﾄ (PWH)", value: "PWH" },
            ],
            smileKitchenSetSelection: [
                "",
                { text: "ﾎﾜｲﾄ・ｳｫｰﾙﾅｯﾄ (WWT)", value: "WWT" },
                { text: "ﾗｲﾄ・ｳｫｰﾙﾅｯﾄ (LWT)", value: "LWT" },
                { text: "ﾋﾞﾀｰ・ｳｫｰﾙﾅｯﾄ (BWT)", value: "BWT" },
            ],
            grandKitchenSetSelection: [
                "",
                { text: "ホワイト (WH)", value: "WH" },
                { text: "サンド (SA)", value: "SA" },
                { text: "グレージュ (GJ)", value: "GJ" },
                { text: "ダーク (D)", value: "D" },
            ],

            smartKitchenCounterSelection: [
                "",
                { text: "純白 (PRW)", value: "PRW" },
                { text: "御影石ｸﾞﾚｰ (GRY)", value: "GRY" },
                { text: "御影石ｱｲﾎﾞﾘｰ (MIV)", value: "MIV" },
                { text: "御影石ﾌﾞﾗｯｸ (MBK)", value: "MBK" },
            ],

            grandKitchenCounterSelection: [
                "",
                { text: "ホワイト (WH)", value: "WH" },
                { text: "ベージュ (BE)", value: "BE" },
                { text: "ブラック (BK)", value: "BK" },
                { text: "御影石アフリカンブラック (ABK)", value: "ABK" },
                { text: "御影石グレー (G)", value: "G" },
            ],

            slitSliderSelection: [
                "",
                { text: "ﾋﾟｭｱ・ﾎﾜｲﾄ (PW)", value: "PW" },
                { text: "スギ・ﾅﾁｭﾗﾙﾄ (SN)", value: "SN" },
            ],

            stonePatternSelection: [
                "",
                { text: "ホワイト (WH)", value: "WH" },
                { text: "ベージュ (BE)", value: "BE" },
                { text: "グレー (G)", value: "G" },
                { text: "ブレック (BK)", value: "BK" },
            ],
            hangingClosetLatticeSelection: [
                "",
                { text: "ヒノキ (LH)", value: "LH" },
                { text: "ブラックパイン (BP)", value: "BP" },
            ],

            // cad_request_house_presentation : [],
            cad_request_house_presentation_content : {
                cad_request_id : null,
                revision : null,
                house_type_id : null,
                is_request_color_info : null,
                drawing_number : null,
                building_type : null,
                artificial_color : null,
                fittings_color : null,
                flooring_1f : null,
                flooring_2f : null,
                flooring_3f : null,
                staircase_color : null,
                kitchen_set : null,
                kitchen_counter : null,
                slit_slider : null,
                stone_patterned_floor : null,
                hanging_closure_unit : null,
                grid_sliding_door : null,
                perspective_direction : null,
                viewpoint_height : null,
                tatami_type_id : null,
                tatami_type : null,
                tatami_color_id : null,
                tatami_color : null,
            },
            existingHp: [],
            newIndex: null,

            // TATAMI SELECTION DIALOG
            dialogTatamiSelection: false,
            tatamiSelectionTarget: null, // 'new' | 'edit'
            tatamiSelectionIndex: null,
            tatamiSelectionHouseTypeId: null,
            tatamiSelectedType: null,  // { tatami_type_id, tatami_type }
            tatamiSelectedColor: null, // { tatami_color_id, tatami_color }

        }
    },

    

    computed : {
        ...mapState([
            'HOUSE_TYPES',
            'cadRequestLatestRevision',
            'cadRequestBasicInformation',
            'cadRequestRevisionContent',
            'cad_request_house_presentation',
            'hideHpTable',
            'intRadio',
            'edit_cad_request_house_presentation',
            'editMode',
            'editRevision',
            'editCadRequestRevisionContent',
            'existingRevisions',
            
            // MASTER SETTINGS DATA
            'FEATURE_COLOR',
            'JOINERY_COLOR',
            'FLOORING_SELECTIONS',
            'KITCHEN_SETS',
            'SLIT_SLIDERS',
            'STONE_PATTERNS',
            'HANGING_CLOSET_LATTICES',
            'HP_STAIRS',
            'KITCHEN_COUNTERS',
            'LATTICE_SLIDING',
            'radio',
            'HP_RESTRICTIONS_PER_HOUSE',
            'VIEW_DIRECTION_SELECTIONS',
            'HP_OBJ_NAME',
            'TATAMI'
        ]),

        isSaveButtonVisible() {
            if(this.step != 3) {
                return false;
            }
            const patternValues = Object.values(this.patterns);
            // Check if patternValues array has at least one non-empty direction value
                return patternValues.some(pattern => pattern.direction);
            // return patternValues.every(pattern => pattern.direction !== null && pattern.direction !== '');
        },

        // TATAMI types available for the current house type
        filteredTatamiTypes() {
            const houseTypeId = this.tatamiSelectionHouseTypeId;
            if (!houseTypeId || !this.TATAMI) return [];

            const seen = new Set();
            const result = [];

            this.TATAMI.forEach(entry => {
                const usesHouseType = entry.tatamihouses && entry.tatamihouses.some(
                    h => h.house_type && h.house_type.id === houseTypeId
                );
                if (usesHouseType && entry.tatami_type && !seen.has(entry.tatami_type.tatami_type_id)) {
                    seen.add(entry.tatami_type.tatami_type_id);
                    result.push(entry.tatami_type);
                }
            });

            return result;
        },

        // TATAMI colors available for the current house type + selected tatami type
        filteredTatamiColors() {
            const houseTypeId = this.tatamiSelectionHouseTypeId;
            const typeId = this.tatamiSelectedType ? this.tatamiSelectedType.tatami_type_id : null;
            if (!houseTypeId || !typeId || !this.TATAMI) return [];

            const seen = new Set();
            const result = [];

            this.TATAMI.forEach(entry => {
                const usesHouseType = entry.tatamihouses && entry.tatamihouses.some(
                    h => h.house_type && h.house_type.id === houseTypeId
                );
                if (
                    usesHouseType &&
                    entry.tatami_type && entry.tatami_type.tatami_type_id === typeId &&
                    entry.tatami_color && !seen.has(entry.tatami_color.tatami_color_id)
                ) {
                    seen.add(entry.tatami_color.tatami_color_id);
                    result.push(entry.tatami_color);
                }
            });

            return result;
        },

    },


    methods: {
        ...mapActions([
                '_getFeatureColorSelection',
                '_getJoineryColorSelection',
                '_getFlooringSelection',
                '_getKitchenSets',
                '_getSlitsliders',
                '_getStonePatterns',
                '_getHangingClosetLattices',
                '_getHpStair',
                '_getKitchenCounter',
                '_getLatticeSliding',
                '_getViewDirectionSelections',
                '_getTatamiDetails'
            ]),


        setEmptySelection(ii){
            if (this.editMode) {
                this.replaceNullWithDefault(this.edit_cad_request_house_presentation[ii], this.HP_OBJ_NAME)
            } else {
                this.replaceNullWithDefault(this.cad_request_house_presentation[ii], this.HP_OBJ_NAME)
            }
        },

        replaceNullWithDefault(obj, restrictedKeys) {
            Object.keys(obj).forEach(key => {
                if (restrictedKeys.includes(key)) {
                    if (obj[key] === null) {
                        obj[key] = '仕様書に準ずる';
                    }
                }
            });

            // this.$forceUpdate()

            return obj
        },

        openTatamiDialog(ii, isEdit) {
            this.tatamiSelectionIndex = ii;
            this.tatamiSelectionTarget = isEdit ? 'edit' : 'new';
            this.tatamiSelectionHouseTypeId = isEdit
                ? this.editCadRequestRevisionContent.house_type_id
                : this.cadRequestBasicInformation.house_type_id;

            const source = isEdit ? this.edit_cad_request_house_presentation : this.cad_request_house_presentation;
            const current = source[ii];

            this.tatamiSelectedType = current && current.tatami_type_id
                ? { tatami_type_id: current.tatami_type_id, tatami_type: current.tatami_type }
                : null;
            this.tatamiSelectedColor = current && current.tatami_color_id
                ? { tatami_color_id: current.tatami_color_id, tatami_color: current.tatami_color }
                : null;

            this.dialogTatamiSelection = true;
        },

        saveTatamiSelection() {
            const source = this.tatamiSelectionTarget === 'edit'
                ? this.edit_cad_request_house_presentation
                : this.cad_request_house_presentation;
            const target = source[this.tatamiSelectionIndex];

            target.tatami_type_id = this.tatamiSelectedType ? this.tatamiSelectedType.tatami_type_id : null;
            target.tatami_type = this.tatamiSelectedType ? this.tatamiSelectedType.tatami_type : null;
            target.tatami_color_id = this.tatamiSelectedColor ? this.tatamiSelectedColor.tatami_color_id : null;
            target.tatami_color = this.tatamiSelectedColor ? this.tatamiSelectedColor.tatami_color : null;

            this.closeTatamiDialog();
        },

        closeTatamiDialog() {
            this.dialogTatamiSelection = false;
            this.tatamiSelectionTarget = null;
            this.tatamiSelectionIndex = null;
            this.tatamiSelectionHouseTypeId = null;
            this.tatamiSelectedType = null;
            this.tatamiSelectedColor = null;
        },

        disableCopyPrevious(item) {
            if(this.editMode) {
                return this.editCadRequestRevisionContent.house_type_id !== item.house_type_id
            } else {
                return this.cadRequestBasicInformation.house_type_id !== item.house_type_id
            }
        },

        openPreviousSelection(ii){
            this.previousHP = true;
            this.newIndex = ii
            
            // console.log(this.newIndex + 1, this.requestPattern)
        },
        
        setPattern(item){
            if(!this.editMode) {
                this.cad_request_house_presentation[this.newIndex] = {...this.cad_request_house_presentation[item]}
                this.previousHP = false;
            } else {
                this.edit_cad_request_house_presentation[this.newIndex] = {...this.edit_cad_request_house_presentation[item]}
                this.previousHP = false;
            }

        },

        copyToLatest(item){
            let hp = {
                is_request_color_info : item.is_request_color_info,
                drawing_number : item.drawing_number,
                building_type : item.building_type,
                artificial_color : item.artificial_color,
                fittings_color : item.fittings_color,
                flooring_1f : item.flooring_1f,
                flooring_2f : item.flooring_2f,
                flooring_3f : item.flooring_3f,
                staircase_color : item.staircase_color,
                kitchen_set : item.kitchen_set,
                kitchen_counter : item.kitchen_counter,
                slit_slider : item.slit_slider,
                stone_patterned_floor : item.stone_patterned_floor,
                hanging_closure_unit : item.hanging_closure_unit,
                grid_sliding_door : item.grid_sliding_door,
                perspective_direction : item.perspective_direction,
                viewpoint_height : item.viewpoint_height,
                tatami_type_id : item.tatami_type_id,
                tatami_type : item.tatami_type,
                tatami_color_id : item.tatami_color_id,
                tatami_color : item.tatami_color,
            }
            if(this.editMode) {
                this.edit_cad_request_house_presentation[this.newIndex] = hp
                // this.edit_cad_request_house_presentation[this.newIndex] = {...this.edit_cad_request_house_presentation[item]}
            } else {
                this.cad_request_house_presentation[this.newIndex] = hp
                // this.cad_request_house_presentation[this.newIndex] = {...this.cad_request_house_presentation[item]}
            }
            this.previousHP = false;
        },

        openHp(){
            this.step = 3;
        },
        closeDialogHpRequestForm(){
            this.dialogHpRequestForm = false;
            this.requestPattern = 0;
            this.step = 2
            if(this.editMode) this.$store.state.edit_cad_request_house_presentation = [];
            else this.$store.state.cad_request_house_presentation = [];

        },
        toggleDialogHousePresentation(value){
            if(this.editMode) {
                this.$emit('toggleDialogHousePresentation', value)
            }else{
                this.$store.state.cad_request_house_presentation = [];
                this.$store.state.radio = 1;
                this.requestPattern = 0;
                this.$emit('toggleDialogHousePresentation', value)

            }
            if(!value){
                if(this.editMode) this.$store.state.editCadRequestRevisionContent.house_presentation = 0;
                else this.$store.state.cadRequestRevisionContent.house_presentation = 0;
            }

        },
        proceedToNext(){
            if(this.$store.state.radio == '依頼なし'){
                this.noRequestDialog = true
                // let ans = confirm('依頼はなしで良いでしょうか。');
                // if(ans){
                //     axios({
                //         method : "POST",
                //         url : "api/house_presentation/delete_hp",
                //         data : {
                //             basicInformation: this.$store.state.cadRequestBasicInformation,
                //             latestRevision: this.$store.state.cadRequestLatestRevision,
                //         }
                //     }).then((res) => {
                //         this.toggleDialogHousePresentation(false)
                //         if(!this.editMode){
                //             this.$store.state.cadRequestRevisionContent.house_presentation = null;
                //             this.cad_request_house_presentation = [];
                //         }else{
                //             this.$store.state.editCadRequestRevisionContent.house_presentation = null;
                //             this.$store.state.edit_cad_request_house_presentation = [];
                //         }

                //     })
                // } else {
                //     this.$store.state.radio = null;
                // }
            } 
            // else if(this.$store.state.radio == '展示場内装確認（打合せ用）INT'){
            //         this.toggleDialogHousePresentation(false)
            //         this.$store.state.cadRequestRevisionContent.house_presentation = 'INT';
            //         this.cad_request_house_presentation = [];
            // }
            else{
                    this.step++;
                }
            
        },
        closeNoRequest(){
            this.noRequestDialog = false
            this.$store.state.radio = null;
        },
        acceptNoRequest(){
            axios({
                method : "POST",
                url : "api/house_presentation/delete_hp",
                data : {
                    basicInformation: this.$store.state.cadRequestBasicInformation,
                    latestRevision: this.$store.state.cadRequestLatestRevision,
                }
            }).then((res) => {
                this.toggleDialogHousePresentation(false)
                if(!this.editMode){
                    this.$store.state.cadRequestRevisionContent.house_presentation = null;
                    // this.cad_request_house_presentation = [];
                    
                }else{
                    this.$store.state.editCadRequestRevisionContent.house_presentation = null;
                    this.$store.state.edit_cad_request_house_presentation = [];
                    
                }
                this.closeNoRequest();
            })
        },
        
        insertingHousePresentationContent(){
                let color_info = null;
                if(!this.$store.state.editMode){

                    this.$store.state.cad_request_house_presentation = []
                    // this.$store.state.cad_request_house_presentation.splice(0);
                    
                    if(this.$store.state.radio == '仕様書に従って作成'){
                        color_info = 0;
                    }else if(this.$store.state.radio == '色情報を指示して依頼'){
                        color_info = 1;
                    }
                    for (let i = 0; i < this.requestPattern; i++) {
                        let data ={
                            cad_request_id : null,
                            revision : null,
                            house_type_id : null,
                            is_request_color_info : color_info,
                            drawing_number : null,
                            building_type : null,
                            artificial_color : null,
                            fittings_color : null,
                            flooring_1f : null,
                            flooring_2f : null,
                            flooring_3f : null,
                            staircase_color : null,
                            kitchen_set : null,
                            kitchen_counter : null,
                            slit_slider : null,
                            stone_patterned_floor : null,
                            hanging_closure_unit : null,
                            grid_sliding_door : null,
                            perspective_direction : null,
                            viewpoint_height : null,
                            tatami_type_id : null,
                            tatami_type : null,
                            tatami_color_id : null,
                            tatami_color : null,
                        }
                        this.cad_request_house_presentation.push(data)
                        data = {}
                    }
                }else{
                    this.$store.state.edit_cad_request_house_presentation.splice(0);

                    if(this.$store.state.radio == '仕様書に従って作成'){
                        color_info = 0;
                    }else if(this.$store.state.radio == '色情報を指示して依頼'){
                        color_info = 1;
                    }
                    for (let i = 0; i < this.requestPattern; i++) {
                        let data = {
                            cad_request_id : null,
                            revision : null,
                            house_type_id : null,
                            is_request_color_info : color_info,
                            drawing_number : null,
                            building_type : null,
                            artificial_color : null,
                            fittings_color : null,
                            flooring_1f : null,
                            flooring_2f : null,
                            flooring_3f : null,
                            staircase_color : null,
                            kitchen_set : null,
                            kitchen_counter : null,
                            slit_slider : null,
                            stone_patterned_floor : null,
                            hanging_closure_unit : null,
                            grid_sliding_door : null,
                            perspective_direction : null,
                            viewpoint_height : null,
                            tatami_type_id : null,
                            tatami_type : null,
                            tatami_color_id : null,
                            tatami_color : null,
                        }
                        this.$store.state.edit_cad_request_house_presentation.push(data)
                        data = {}
                    }
                }
        },
        storeData(){
            if(!this.$store.state.editMode){
                for (let i = 0; i < this.cad_request_house_presentation.length; i++) {
                    if(this.patterns[i+1].direction){
                        this.cad_request_house_presentation[i].perspective_direction = this.patterns[i+1].direction;
                        // this.cad_request_house_presentation[i].viewpoint_height = this.patterns[i+1].height;
                    }else{
                        alert('Please fill out all fields!')
                        return false;
                    }
                }
            }else{
                for (let i = 0; i < this.edit_cad_request_house_presentation.length; i++) {
                    if(this.patterns[i+1].direction){
                        this.edit_cad_request_house_presentation[i].perspective_direction = this.patterns[i+1].direction;
                        // this.cad_request_house_presentation[i].viewpoint_height = this.patterns[i+1].height;
                    }else{
                        alert('Please fill out all fields!')
                        return false;
                    }
                }
            }
            // console.log()
            this.saveHousePresentation();
        },
        saveHousePresentation(){
            if(!this.$store.state.editMode){
                this.$store.state.cadRequestRevisionContent.house_presentation = 1;
                this.$store.state.hideHpTable = this.cad_request_house_presentation[0].is_request_color_info;
            }else{
                this.$store.state.editCadRequestRevisionContent.house_presentation = 1;
                this.$store.state.hideHpTable = this.edit_cad_request_house_presentation[0].is_request_color_info;
            }
                this.$emit('toggleDialogHousePresentation', false);
                this.$store.state.radio = 1;
                this.dialogHpRequestForm = false;

        },
        house_presentation(){
            this.$emit('house_presentation', this.cad_request_house_presentation)
            this.toggleDialogColorPerspective(false)
        },

        kitchenPerHouse(){
            // FOR KITCHEN COUNTER FILTER HOUSE TYPE
            this.filteredKitchen = []
            this.KITCHEN_SETS.map((res) => {
                // console.log(res,'res')
                if(res.kitchensethouse.length > 0){
                    res.kitchensethouse.forEach(element => {
                        if(element.house_type_id == this.cadRequestBasicInformation.house_type_id) {
                            this.filteredKitchen.push(res);
                        }
                    });
                }
            })

            // FOR KITCHEN COUNTER FILTER HOUSE TYPE
            this.filteredKitchenSet = []
            this.KITCHEN_COUNTERS.map((res) => {
                // console.log(res,'res')
                if(res.kitchenhouse.length > 0){
                    res.kitchenhouse.forEach(kitchenSet => {
                        if(kitchenSet.house_type_id == this.cadRequestBasicInformation.house_type_id){
                            this.filteredKitchenSet.push(res);
                        }
                    })
                }
            })

            // FOR FLOORING FILTER HOUSE TYPE
            this.filteredFlooring = []
            this.FLOORING_SELECTIONS.map((res) => {
                // console.log(res,'Flooring')
                if(res.flooringhouse.length > 0){
                    res.flooringhouse.forEach(floorSelect => {
                        if(floorSelect.house_type_id == this.cadRequestBasicInformation.house_type_id) {
                            this.filteredFlooring.push(res);
                        }
                    })
                }
            })

        },


    },
    watch : {
        "$store.state.existingRevisions"(val){
            this.existingHp = []
            if(val){
                val.filter(r => {
                    if(r.hp.length > 0){
                        r.hp.map(element => {
                            if(element){
                                if(element.is_request_color_info == '1'){
                                    element.temp_created = moment(element.created_at).format("MM/DD")
                                    element.house_type_id = parseInt(element.house_type_id)
                                    // return element;
                                    this.existingHp.push(element)
                                }
                            }
                            // this.existingColorPers = this.existingColorPers.map((r) => {
                            //     r.temp_created = moment(r.created_at).format("MM/DD")
                            //     return r;
                            // })
                        });
                    }
                })
                // console.log(this.existingHp, 'this.existingHp')
            }
        },

        dialogHpRequestForm(){
            // console.log(this.$store.state.edit_cad_request_house_presentation, "editssssssss")
        },
        housePresentation(val){
            if(val){
                this.$emit("emmitedHp",this.cad_request_house_presentation)
            }
        },
        dialog(val) {
            if(!val){
                this.patterns[1].direction = null
                this.patterns[1].height = null

                this.patterns[2].direction = null
                this.patterns[2].height = null

                this.patterns[3].direction = null
                this.patterns[3].height = null

                this.patterns[4].direction = null
                this.patterns[4].height = null

                // this.$store.state.radio = null
                this.requestPattern = 0
                this.step = 1
            }else{
                // console.log(this.$store.state.edit_cad_request_house_presentation, this.$store.state.editCadRequestRevisionContent, 'edithp')
                this.kitchenPerHouse()
                if(this.cad_request_house_presentation){
                    if(this.cad_request_house_presentation.length != 0){
                        // console.log(this.cad_request_house_presentation,"cad_request_house_presentation", this.patterns);
                        this.$store.state.radio = this.requestContents.filter(rec=> rec.value == this.cad_request_house_presentation[0].is_request_color_info + 1)[0].text 
                        this.requestPattern = this.cad_request_house_presentation.length
                        if(this.$store.state.radio == '仕様書に従って作成'){
                            this.step++;
                            if(this.requestPattern){
                                this.step++
                                for (let i = 1; i <= this.cad_request_house_presentation.length; i++) {
                                    // this.patterns[i].height = this.cad_request_house_presentation[i-1].viewpoint_height;
                                    this.patterns[i].direction = this.cad_request_house_presentation[i-1].perspective_direction;
                                    // console.log(this.patterns[i].direction)
                                }
                            }
                        }else{
                            this.step++;
                            if(this.requestPattern){
                                this.dialogHpRequestForm = true;
                            }
                        }
                    }
                }

                if(this.$store.state.edit_cad_request_house_presentation){                
                    if(this.$store.state.edit_cad_request_house_presentation.length != 0){
                        this.$store.state.radio = this.requestContents.filter(rec=> rec.value == this.edit_cad_request_house_presentation[0].is_request_color_info + 1)[0].text 
                        this.requestPattern = this.edit_cad_request_house_presentation.length
                        if(this.$store.state.radio == '仕様書に従って作成'){
                            this.step++;
                            if(this.requestPattern){
                                this.step++
                                for (let i = 1; i <= this.edit_cad_request_house_presentation.length; i++) {
                                    this.patterns[i].height = this.edit_cad_request_house_presentation[i-1].viewpoint_height;
                                    this.patterns[i].direction = this.edit_cad_request_house_presentation[i-1].perspective_direction;
                                }
                            }
                        }else{
                            this.step++;
                            let tempHP = [];
                                    for (let i = 0; i < this.edit_cad_request_house_presentation.length; i++) {
                                        let data ={
                                            cad_request_id : this.edit_cad_request_house_presentation[i].cad_request_id,
                                            revision : this.edit_cad_request_house_presentation[i].revision,
                                            house_type_id : this.edit_cad_request_house_presentation[i].house_type_id,
                                            is_request_color_info : this.edit_cad_request_house_presentation[i].is_request_color_info,
                                            drawing_number : this.edit_cad_request_house_presentation[i].drawing_number,
                                            building_type : this.edit_cad_request_house_presentation[i].building_type,
                                            artificial_color : this.edit_cad_request_house_presentation[i].artificial_color,
                                            fittings_color : this.edit_cad_request_house_presentation[i].fittings_color,
                                            flooring_1f : this.edit_cad_request_house_presentation[i].flooring_1f,
                                            flooring_2f : this.edit_cad_request_house_presentation[i].flooring_2f,
                                            flooring_3f : this.edit_cad_request_house_presentation[i].flooring_3f,
                                            staircase_color : this.edit_cad_request_house_presentation[i].staircase_color,
                                            kitchen_set : this.edit_cad_request_house_presentation[i].kitchen_set,
                                            kitchen_counter : this.edit_cad_request_house_presentation[i].kitchen_counter,
                                            slit_slider : this.edit_cad_request_house_presentation[i].slit_slider,
                                            stone_patterned_floor : this.edit_cad_request_house_presentation[i].stone_patterned_floor,
                                            hanging_closure_unit : this.edit_cad_request_house_presentation[i].hanging_closure_unit,
                                            grid_sliding_door : this.edit_cad_request_house_presentation[i].grid_sliding_door,
                                            perspective_direction : this.edit_cad_request_house_presentation[i].perspective_direction,
                                            viewpoint_height : this.edit_cad_request_house_presentation[i].viewpoint_height,
                                            tatami_type_id : this.edit_cad_request_house_presentation[i].tatami_type_id,
                                            tatami_type : this.edit_cad_request_house_presentation[i].tatami_type,
                                            tatami_color_id : this.edit_cad_request_house_presentation[i].tatami_color_id,
                                            tatami_color : this.edit_cad_request_house_presentation[i].tatami_color,
                                        }
                                        tempHP.push(data)
                                        data = {}
                                    }
                                this.$store.state.edit_cad_request_house_presentation = [];
                                this.$store.state.edit_cad_request_house_presentation = tempHP;
                                // console.log(this.edit_cad_request_house_presentation, "edit")
                                this.dialogHpRequestForm = true;
                        }
                    }
                }
                // else{
                //     for (let i = 0; i < this.requestPattern; i++) {
                //         let data = {
                //             cad_request_id : null,
                //             revision : null,
                //             house_type_id : null,
                //             is_request_color_info : color_info,
                //             drawing_number : null,
                //             building_type : null,
                //             artificial_color : null,
                //             fittings_color : null,
                //             flooring_1f : null,
                //             flooring_2f : null,
                //             flooring_3f : null,
                //             staircase_color : null,
                //             kitchen_set : null,
                //             kitchen_counter : null,
                //             slit_slider : null,
                //             stone_patterned_floor : null,
                //             hanging_closure_unit : null,
                //             grid_sliding_door : null,
                //             perspective_direction : null,
                //             viewpoint_height : null,
                //         }
                //         tempHP.push(data)
                //         data = {}
                //     }
                //     console.log(tempHP, "tempssssss")
                // }
            }
        },
    },

    mounted() {
        this._getFeatureColorSelection();
        this._getJoineryColorSelection();
        this._getFlooringSelection();
        this._getKitchenSets();
        this._getSlitsliders();
        this._getStonePatterns();
        this._getHangingClosetLattices();
        this._getHpStair();
        this._getKitchenCounter();
        this._getLatticeSliding();
        this._getViewDirectionSelections();
        this._getTatamiDetails();
    },
}
</script>

<style scoped>
    .v-data-table.colorView th {
        border: 1px solid black;
        border-left: 1px solid black !important;
        border-right: 1px solid black !important;
        border-bottom: 1px solid black !important;
    }

     .v-data-table.colorView td {
        border-bottom: 1px solid white !important;
    }

     .v-data-table.requestView td {
        border-top: 1px solid black ;
        border-right: 1px solid black !important;
        border-left: 1px solid black !important;
    }
    
    .left-sticky {
        position: sticky;
        left: 0;
        z-index: 1;
        border-top: 1px solid black !important;
        border-left: 1px solid black !important;
        border-right: 1px solid black !important;
    }

    .existing-request{
        background: #d1d4d1!important;
        color: black!important;
        border-top: 1px solid black !important;
        border-right: 1px solid black !important;
    }
    .req-divider{
        border-top: 1px solid black !important;
        background: #34495e!important;
    }

    /* CASE WHEN REQUEST PATTERN == 4 */
    .pattern-4-1{
        min-width: 200px !important;
        position: sticky;
        right: 600px;
        z-index: 1;
        background: whitesmoke;
        color: black!important;
        border-bottom-color: black !important;

    }
    .pattern-4-2{
        min-width: 200px !important;
        position: sticky;
        right: 400px;
        z-index: 1;
        background: whitesmoke;
        color: black!important;
        border-bottom-color: black !important;
    }
    .pattern-4-3{
        min-width: 200px !important;
        position: sticky;
        right: 200px;
        z-index: 1;
        background: whitesmoke;
        color: black!important;
        border-bottom-color: black !important;
    }
    .pattern-4-4{
        min-width: 200px !important;
        position: sticky;
        right: 0px;
        z-index: 1;
        background: whitesmoke;
        color: black!important;
        border-bottom-color: black !important;
    }

    /* CASE WHEN REQUEST PATTERN == 3 */
    .pattern-3-1{
        min-width: 200px !important;
        position: sticky;
        right: 400px;
        z-index: 1;
        background: whitesmoke;
        color: black!important;
        border-bottom-color: black !important;
    }
    .pattern-3-2{
        min-width: 200px !important;
        position: sticky;
        right: 200px;
        z-index: 1;
        background: whitesmoke;
        color: black!important;
        border-bottom-color: black !important;
    }
    .pattern-3-3{
        min-width: 200px !important;
        position: sticky;
        right: 0;
        z-index: 1;
        background: whitesmoke;
        color: black!important;
        border-bottom-color: black !important;
    }

    /* CASE WHEN REQUEST PATTERN == 2 */
    .pattern-2-1{
        min-width: 200px !important;
        position: sticky;
        right: 200px;
        z-index: 1;
        background: whitesmoke;
        color: black!important;
        border-bottom-color: black !important;
    }
    .pattern-2-2{
        min-width: 200px !important;
        position: sticky;
        right: 0;
        z-index: 1;
        background: whitesmoke;
        color: black!important;
        border-bottom-color: black !important;
    }

    /* CASE WHEN REQUEST PATTERN == 1 */
    .pattern-1-1{
        min-width: 200px !important;
        position: sticky;
        right: 0;
        z-index: 1;
        background: whitesmoke;
        color: black!important;
        border-bottom-color: black !important;
    }

    .top-sticky {
        position: sticky;
        top: 0;
        z-index: 1;
    }



    /*  */

    .image-header-sticky{
        position: sticky;
        top: 1px !important;
        left: 98px !important;
        z-index: 2 !important;
        background: #d1d4d1;
        border-left-color: black !important;
        border-right-color: black !important;
    }

    .disabled-background{
        background-color: #34495E
    }
</style>
